export const TOKEN_EXPIRY_OFFSET_MS = 10 * 60 * 1000;
